import { render, staticRenderFns } from "./DocUploadSidebar.vue?vue&type=template&id=52236a1c&scoped=true&"
import script from "./DocUploadSidebar.vue?vue&type=script&lang=js&"
export * from "./DocUploadSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DocUploadSidebar.vue?vue&type=style&index=0&id=52236a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52236a1c",
  null
  
)

export default component.exports